import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getPetugasGrader = 'petugas-grader';
const getPetugasGraderAktif = 'petugas-grader';
const getPetugasGraderTidakAktif = 'petugas-grader';
const postPetugasGrader = 'petugas-grader';
const putPetugasGrader = 'petugas-grader/';
const deletePetugasGrader = 'petugas-grader/';
const getPetugasGraderById = 'petugas-grader/';
const exportPetugasGrader = '';

class PetugasGraderService {
    getPetugasGrader(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getPetugasGrader + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }

    getPetugasGraderAktif(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getPetugasGraderAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&status=1&sortBy=id',
            {
                headers: authHeader()
            }
        );
    }

    getPetugasGraderTidakAktif(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getPetugasGraderTidakAktif + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&sortBy=id' + '&status=0' + '&filter=' + filter,
            {
                headers: authHeader()
            }
        )
    }

    postPetugasGrader(formData) {        
        var headers = authHeader();
        var form = new FormData();

        form.append("name", formData.name);
        form.append("username", formData.username);
        form.append("email", formData.email);
        form.append("noTelephone", formData.noTelephone);
        form.append("alamat", formData.alamat);
        form.append("password",formData.password);
        form.append("divisi",formData.divisi);
        form.append("status", formData.status);
        form.append("instansi", formData.instansi);
        if (typeof formData.foto !== 'undefined') {
            form.append("foto", formData.foto);
        }
        
        return axios
        .post(
            API_URL + postPetugasGrader,
            form,
            {  headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
        );

    }

    putPetugasGrader(id_user, formData) {

        var form = new FormData();

        form.append("name", formData.name);
        form.append("username", formData.username);
        form.append("email", formData.email);
        form.append("divisi",formData.divisi);
        form.append("noTelephone", formData.noTelephone);
        form.append("alamat", formData.alamat);
        form.append("password",formData.password);
        form.append("status", formData.status);
        form.append("instansi", formData.instansi);
        if (typeof formData.foto !== 'undefined') {
            form.append("foto", formData.foto);
        }
        
        return axios
        .put(
            API_URL + putPetugasGrader + id_user,
            form,
            {  headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
        );

    }

    deletePetugasGrader(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePetugasGrader + formData.id,
                { headers: authHeader() }
            );
    }

    getPetugasGraderById(id) {
        var headers = authHeader();

        return axios
        .get(
            API_URL + getPetugasGraderById + id,
            { headers: authHeader() }
        );
    }

    exportPetugasGraderAktif() {
        return axios.get(API_URL + exportPetugasGrader, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    exportPetugasGraderTidakAktif() {
        return axios.get(API_URL + exportPetugasGrader, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

}

export default new PetugasGraderService();